import React, { memo } from 'react';
import classNames from 'classnames';

import { Spinner } from '../helpers/Spinner';

/**
 * Appends loading animation to a component.
 *
 * @param Comp {React.Component} Component has loading state.
 * @param [loadFieldName='loading'] {String} Name of loading field.
 * @param extraClassName {Boolean} Extra class name to be added to the component.
 * @param isButton {Boolean} Whether the component is a button.
 */
export default function LoadAnimationWrapper(Component, loadFieldName = 'loading', extraClassName, isButton = false) {
  const componentName = Component.displayName || Component.name;

  const Wrapped = memo(props => {
    const isLoading = props[loadFieldName] || false;

    const loadContent = isLoading ? <Spinner className="spinner--overlay" /> : null;

    if (isButton) {
      return (
        <Component {...props} disabled={isLoading}>
          <>
            {props.children} {isLoading && <Spinner className="p-static" size="small" inline />}
          </>
        </Component>
      );
    }

    return (
      <div className={classNames('load-wrapper full-height', extraClassName)}>
        {loadContent}
        <Component {...props} />
      </div>
    );
  });

  Wrapped.displayName = `LoadAnimated$${componentName}`;

  return Wrapped;
}
